import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/waist-hip-ratio',
  component: () => import('../../routes/WaistHipRatio.svelte'),
  card: {
    id: 'waist-hip-ratio',
    title: 'Waist-Hip Ratio (WHR)',
    description: 'Calculate your waist-to-hip ratio to assess body shape and cardiovascular health risk.',
    icon: 'straighten',
    iconBgClass: 'bg-rose-50',
    iconTextClass: 'text-rose-600',
    href: '/waist-hip-ratio',
    category: 'Weight & Nutrition',
  },
  seo: {
    title: 'Waist-Hip Ratio Calculator — Measure Body Shape & Health Risk',
    description: 'Free WHR calculator to assess your waist-to-hip ratio and evaluate cardiovascular risk based on WHO apple vs. pear body shape thresholds.',
  },
};

export default meta;
